import React, { Component } from 'react';
import Header from '../header';
import Slider from './views/slider';
import Discover from './views/discoverServices';
import Section from './views/section';
import Message from './views/sectionMessage';
import Stories from './views/stories';
import Questions from './views/questions';
import Footer from '../footer';
import * as DataStatic from '../../api/homeDataStatic';
import './style.scss';

class Homepage extends Component{
  constructor() {
    super();
  }
  render(){
    return(
      <div className="page">
        <Header key="home" animation={true} page="homepage"/>
        <Slider />
        <Discover />
        <Section content={DataStatic.SectionCustom}/>
        <Section content={DataStatic.SectionDevelopment}/>
        <Section content={DataStatic.SectionAgile} />
        <Message content={DataStatic.SectionMessage} />
        <Stories content={DataStatic.Stories}/>
        <Questions content={DataStatic.Questions} />
        <Footer />
      </div>
    )
  }
}

export default Homepage;



// WEBPACK FOOTER //
// ./src/components/homepage/index.js